import { useEffect, useState } from "react";
import { Link } from "wouter";
import { Building2, ShieldCheck } from "lucide-react";
import { api } from "../lib/api";

/**
 * v3.9.0 Phase 6b — taxonomy-matched organizations suggested for a posted
 * project or RFQ. Matches the need's category/title/items against each org's
 * business roles, industry, and products; verified organizations surface first.
 * Renders nothing when there are no matches (so it never adds empty noise).
 */
export function SuggestedOrgs({ kind, id }: { kind: "projects" | "rfqs"; id: string }) {
  const [items, setItems] = useState<any[] | null>(null);
  useEffect(() => {
    let alive = true;
    api.suggestedOrgs(kind, id).then((r) => { if (alive) setItems(r); }).catch(() => { if (alive) setItems([]); });
    return () => { alive = false; };
  }, [kind, id]);

  if (!items || items.length === 0) return null;
  return (
    <div className="card p-5">
      <h3 className="font-bold text-navy mb-1 flex items-center gap-2"><Building2 className="w-4 h-4" />Suggested organizations</h3>
      <p className="text-xs text-mut mb-3">Verified organizations whose profile matches this {kind === "rfqs" ? "request" : "project"}.</p>
      <div className="space-y-2">
        {items.map((c) => (
          <Link key={c.id} href={`/c/${c.id}`} className="flex items-start gap-3 border border-line rounded-lg p-3 hover:border-navy transition">
            <div className="w-9 h-9 rounded-lg bg-navy text-white text-xs font-bold grid place-items-center shrink-0">{c.initials}</div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-1.5">
                <span className="font-semibold text-navy text-sm truncate">{c.name}</span>
                {c.verified && <ShieldCheck className="w-3.5 h-3.5 text-brand-green shrink-0" />}
              </div>
              <div className="text-xs text-mut truncate">{[c.subtype, c.primaryIndustry, c.serviceCoverage].filter(Boolean).join(" · ") || c.city}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
